import React, { Component } from 'react';
import BlogsCards from '../Components/BlogsCards';
import NavBar from '../Components/NavBar';
import './Looking-for-a-visual-designer.css';
import MoreCards from '../Components/MoreCards';


const LookingForVisualDesigner = () => {
    return ( 
        <>
        <NavBar />
        <section className='marginT'>

        <BlogsCards bloghead='Looking for a visual designer?' blogp='I studied UI/UX design, 3d modelling, Branding , UX Research, Video Editing, UX design, UI design, Graphic Design at Uni. I also took an external graphic design course. I am very passionate about ART ever since childhood. i took lots of different course of art. I started drawing at the age of 5. after taking UI/UX design and graphic design my skill were best in UI design and Graphic design so i decided to improve these skills at most, I worked freelancer as a Graphic designer so I have experience working and I got a great feedback from my clients.When I discovered UI/UX and Graphic Design, everything suddenly connected. These fields allowed me to merge my love for visuals with problem-solving, storytelling, and functionality. Over time, my strongest skills naturally formed in UI design and graphic design, and that motivated me to invest even more time into mastering them. I pushed myself, practiced constantly, and explored different tools, techniques, and workflows to level up my craft.
I’ve also worked as a freelance Graphic Designer, which helped me gain real experience handling client projects, deadlines, and creative direction. Through that, I received great feedback from clients who appreciated my attention to detail, communication, and ability to bring ideas to life. Every project made me more confident in the designer I’m becoming.
Today, I continue to grow, experiment, and expand my visual language. Art has always been my starting point, and design has become the way I express it with purpose.'  />
        
</section>
        
      <MoreCards />  
        
        
        
        
        
        </>
     );
}
 
export default LookingForVisualDesigner;